import type { SvgIconComponent } from '@mui/icons-material';
import { cn } from '@/utils/cn';

interface PageTitleIconProps {
  icon: SvgIconComponent;
  size?: 'sm' | 'md';
  className?: string;
}

export function PageTitleIcon({ icon: Icon, size = 'md', className }: PageTitleIconProps) {
  return (
    <span
      className={cn(
        'flex shrink-0 items-center justify-center rounded-lg bg-primary-50 text-primary-700 dark:bg-primary-950/50 dark:text-primary-300',
        size === 'sm' ? 'h-8 w-8' : 'h-9 w-9',
        className,
      )}
      aria-hidden
    >
      <Icon sx={{ fontSize: size === 'sm' ? 20 : 22 }} />
    </span>
  );
}
